// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Icon, { IconWrapper } from "@insite/mobius/Icon"; // Starter Custom Code
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Starter Custom Code - Start */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { injectCss } from "@insite/mobius/utilities";
import AlertCircleFill, {
    AlertCircleFillOffset,
} from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleFill";
import AlertTriangleFill, {
    AlertTriangleFillOffset,
} from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import CheckmarkCircle2Fill, {
    CheckmarkCircle2FillOffset,
} from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle2/CheckmarkCircle2Fill";
import InfoFill from "@store/Library/Components/Toolkit/Icons/Info/InfoFill";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import { StatusColor, statusStyles } from "@store/Themes/common/mixins/status";
import { loadingDotsStyles } from "@store/Themes/common/mixins/typography";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

export const useShowProductAvailability = () => {
    const showInventoryToggle = useAppSelector(state => Boolean(state.context.showInventory));
    const showInventorySetting = useAppSelector(
        state => getSettingsCollection(state).productSettings.showInventoryAvailability,
    );

    return showInventoryToggle && showInventorySetting;
};
/* Starter Custom Code - End */

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    // Starter Custom Code
    overridedStyles?: ProductAvailabilityStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    showInventory: state.context.showInventory,
});

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    // Starter Custom Code
    availabilityByWarehouseIcon?: IconPresentationProps;
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
}

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    availabilityByWarehouseLink: {
        icon: {
            position: "left",
            iconProps: {
                src: InfoFill,
                size: 18,
                css: css`
                    margin-right: 0;
                    color: inherit;
                `,
            },
        },
        css: css`
            ${linkAltStyles()}
            margin-left: ${pxToRem(5)};
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "small",
        cssOverrides: {
            modalContent: css`
                padding: ${pxToRem(10)};
            `,
        },
    },
    availabilityByWarehouseTable: {
        css: css`
            ${x => x.theme.dataTable.defaultProps?.css}
            border: none;
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
        `,
    },
    realTimeText: {
        css: loadingDotsStyles(),
    },
};

/* Starter Custom Code - Start */
const InventoryMessage = styled.div<{ _color: StatusColor; _iconOffset?: IconOffset }>`
    ${x => statusStyles(x._color, x._iconOffset)}
    ${injectCss}
`;
/* Starter Custom Code - End */

// Starter Custom Code - next line - return type: StatusColor
const getAvailabilityColor = (productSettings: ProductSettingsModel, availability?: AvailabilityDto): StatusColor => {
    if (!productSettings.showInventoryAvailability) {
        return "neutral"; // Starter Custom Code
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return "danger";
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return "warning";
    }

    return "success";
};

const getAvailabilityIcon = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return {}; // Starter Custom Code
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return { iconSrc: AlertTriangleFill, iconOffset: AlertTriangleFillOffset }; // Starter Custom Code
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return { iconSrc: AlertTriangleFill, iconOffset: AlertTriangleFillOffset }; // Starter Custom Code
    }

    return { iconSrc: CheckmarkCircle2Fill, iconOffset: CheckmarkCircle2FillOffset }; // Starter Custom Code
};

const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }

    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }

    return !!isProductDetailsPage;
};

const ProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    // Starter Removed - showInventory
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };

    const color = getAvailabilityColor(productSettings, availability);
    const { iconSrc, iconOffset } = getAvailabilityIcon(productSettings, availability); // Starter Custom Code

    const showInventory = useShowProductAvailability(); // Starter Custom Code
    const styles = useExpandProps(productAvailabilityStyles, extendedStyles, overridedStyles); // Starter Custom Code
    if (!showInventory) {
        return null;
    }

    /* Starter Custom Code - Start */
    const unavailableMessage = (
        <InventoryMessage _color="neutral" _iconOffset={AlertCircleFillOffset} {...styles.inventoryMessage}>
            <Icon color="neutral" src={AlertCircleFill} />
            <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                {siteMessage("RealTimeInventory_InventoryLoadFailed")}
            </Typography>
        </InventoryMessage>
    );
    /* Starter Custom Code - End */

    if (failedToLoadInventory) {
        return <StyledWrapper {...styles.wrapper}>{unavailableMessage}</StyledWrapper>; // Starter Custom Code
    }

    let inventoryTextComponent = <Typography {...styles.realTimeText} />;
    if (availability?.messageType !== AvailabilityMessageType.NoMessage && availability?.message?.length) {
        inventoryTextComponent = (
            <InventoryMessage
                _color={color} // Starter Custom Code
                _iconOffset={iconOffset} // Starter Custom Code
                {...styles.inventoryMessage}
            >
                <Icon color={color} src={iconSrc} />
                <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                    {availability.message}
                </Typography>
            </InventoryMessage>
        );
    } else if (availability) {
        inventoryTextComponent = unavailableMessage; // Starter Custom Code
    }

    /* Starter Removed - Grid */
    return (
        <StyledWrapper {...styles.wrapper /* Starter Custom Code */}>
            {inventoryTextComponent /* Starter Custom Code */}
            {showLink(availability, trackInventory, productSettings, isProductDetailsPage) && (
                <>
                    <Link
                        {...styles.availabilityByWarehouseLink}
                        onClick={viewAvailabilityByWarehouseClickHandler}
                        data-test-selector="availabilityByWarehouseLink"
                        title={translate("View Availability by Warehouse") /* Starter Custom Code */}
                    />
                    <Modal
                        {...styles.availabilityByWarehouseModal}
                        headline={translate("Warehouse Inventory")}
                        isOpen={modalIsOpen}
                        handleClose={modalCloseHandler}
                    >
                        {isLoading && <Loader /> /* Starter Custom Code */}
                        {!isLoading && (
                            <>
                                {errorMessage ? (
                                    <div>{errorMessage}</div>
                                ) : (
                                    <DataTable
                                        {...styles.availabilityByWarehouseTable}
                                        data-test-selector="availabilityByWarehouseModal"
                                    >
                                        <DataTableHead {...styles.availabilityByWarehouseTableHead}>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("Warehouse")}
                                            </DataTableHeader>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("QTY")}
                                            </DataTableHeader>
                                        </DataTableHead>
                                        <DataTableBody {...styles.availabilityByWarehouseTableBody}>
                                            {warehouses?.map(warehouse => (
                                                <DataTableRow
                                                    {...styles.availabilityByWarehouseTableRow}
                                                    key={warehouse.name}
                                                >
                                                    <DataTableCell
                                                        {...styles.availabilityByWarehouseTableCell}
                                                        data-test-selector="warehouseAvailabilityModal_Description"
                                                    >
                                                        {warehouse.description || warehouse.name}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...styles.availabilityByWarehouseTableCell}
                                                        data-test-selector="warehouseAvailabilityModal_Quantity"
                                                    >
                                                        {warehouse.qty}
                                                    </DataTableCell>
                                                </DataTableRow>
                                            ))}
                                        </DataTableBody>
                                    </DataTable>
                                )}
                            </>
                        )}
                    </Modal>
                </>
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailability);
